import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiGet } from '../../lib/api';

interface Item {
  id: string;
  title: string;
  body: string | null;
  partner?: string | null;
  valid_to?: string | null;
}

/** 優惠（tab 1）—— 讀已發佈內容（由 admin 管理台維護） */
export default function BenefitsPage() {
  const { t } = useTranslation();
  const [items, setItems] = useState<Item[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    void apiGet<{ items: Item[] }>('/api/content/benefits').then((r) => {
      if (r.ok && r.data) setItems(r.data.items);
      setLoaded(true);
    });
  }, []);

  return (
    <div className="max-w-md mx-auto">
      <h2 className="text-lg font-bold mb-3">{t('tab.benefits')}</h2>
      {loaded && items.length === 0 && <p style={{ color: 'var(--color-text-secondary)' }}>{t('empty_none')}</p>}
      <div className="grid gap-3">
        {items.map((b) => (
          <article key={b.id} className="rounded-xl p-4" style={{ background: 'var(--color-card)', boxShadow: 'var(--shadow-card)' }}>
            <h3 className="font-bold">{b.title}</h3>
            {b.partner ? (
              <p className="text-sm" style={{ color: 'var(--color-accent-strong)' }}>
                {b.partner}
              </p>
            ) : null}
            {b.body ? (
              <p className="text-sm mt-1" style={{ color: 'var(--color-text-secondary)', whiteSpace: 'pre-wrap' }}>
                {b.body}
              </p>
            ) : null}
          </article>
        ))}
      </div>
    </div>
  );
}

